/*
 * Landing-page invitation leads — /naytive-landing-leads
 *
 * People who submit "Request an invitation" on the naytive.com marketing
 * landing (root "Intelligent Account", /smartaccount …). Captured by v3
 * POST /api/waitlist into `landing_leads`; ops is also emailed (r@/k@/kim@).
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Sidebar from '../components/Sidebar';
import { naytiveAPI } from '../services/api';

const NaytiveLandingLeads = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [toast, setToast] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const r = await naytiveAPI.listLandingLeads();
      setItems(r.data.items || []);
    } catch (e) {
      console.error('[landingLeads] load failed', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (toast) { const t = setTimeout(() => setToast(null), 2500); return () => clearTimeout(t); } }, [toast]);

  const rows = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return items;
    return items.filter((r) => (r.email || '').toLowerCase().includes(s) || (r.source || '').toLowerCase().includes(s));
  }, [items, q]);

  const remove = async (id) => {
    if (!window.confirm('Delete this lead?')) return;
    try {
      await naytiveAPI.deleteLandingLead(id);
      setItems((prev) => prev.filter((r) => r.id !== id));
      setToast({ type: 'success', message: 'Deleted' });
    } catch (e) {
      setToast({ type: 'error', message: 'Delete failed' });
    }
  };

  const fmt = (d) => d ? new Date(d).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';

  const th = { textAlign: 'left', padding: '10px 14px', fontSize: 12, letterSpacing: '.04em', textTransform: 'uppercase', color: '#7c879e', borderBottom: '1px solid #e6e9f0' };
  const td = { padding: '11px 14px', fontSize: 14, borderBottom: '1px solid #eef1f6', color: '#1a1f36' };

  return (
    <div className="page-layout" style={{ display: 'flex' }}>
      <Sidebar />
      <main className="page-content" style={{ flex: 1, padding: 28, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, marginBottom: 6 }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700 }}>Landing Leads</h1>
            <p style={{ margin: '4px 0 0', color: '#667', fontSize: 14 }}>"Request an invitation" submissions from the marketing landing pages.</p>
          </div>
          <button onClick={load} style={{ border: '1px solid #d9dbe4', background: '#fff', borderRadius: 8, padding: '9px 16px', fontWeight: 600, cursor: 'pointer' }}>Refresh</button>
        </div>

        <div style={{ display: 'flex', gap: 12, alignItems: 'center', margin: '18px 0' }}>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search email or source…" style={{ flex: 1, maxWidth: 360, padding: '10px 12px', border: '1px solid #d9dbe4', borderRadius: 8, fontSize: 14 }} />
          <span style={{ color: '#7c879e', fontSize: 13 }}>{rows.length} lead{rows.length === 1 ? '' : 's'}</span>
        </div>

        <div style={{ background: '#fff', border: '1px solid #e6e9f0', borderRadius: 12, overflow: 'hidden' }}>
          {loading ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#7c879e' }}>Loading…</div>
          ) : rows.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#7c879e' }}>No leads yet. Submissions from naytive.com "Request an invitation" appear here.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={th}>Email</th>
                    <th style={th}>Source</th>
                    <th style={th}>IP</th>
                    <th style={th}>When</th>
                    <th style={th}></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id}>
                      <td style={{ ...td, fontWeight: 500 }}>{r.email}</td>
                      <td style={td}>{r.source}</td>
                      <td style={{ ...td, color: '#7c879e', fontVariantNumeric: 'tabular-nums' }}>{r.ip || '-'}</td>
                      <td style={{ ...td, color: '#47536e', whiteSpace: 'nowrap' }}>{fmt(r.created_at)}</td>
                      <td style={{ ...td, textAlign: 'right' }}>
                        <button onClick={() => remove(r.id)} style={{ border: 'none', background: 'transparent', color: '#c0392b', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>Delete</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {toast && (
          <div style={{ position: 'fixed', bottom: 24, right: 24, background: toast.type === 'error' ? '#c0392b' : '#1e8449', color: '#fff', padding: '10px 18px', borderRadius: 8, fontWeight: 600 }}>{toast.message}</div>
        )}
      </main>
    </div>
  );
};

export default NaytiveLandingLeads;
